import { motion } from "framer-motion";
import { Phone, Home, Ruler, Factory, Wrench } from "lucide-react";

const STEPS = [
  { icon: Phone,   title: "Primer Contacto",     text: "Cuéntanos tu proyecto por WhatsApp, llamada o formulario." },
  { icon: Home,    title: "Visita a Domicilio",       text: "Agendamos visita al domicilio u oficina sin compromiso." },
  { icon: Ruler,   title: "Medición Profesional",     text: "Toma de medidas precisa y asesoría de materiales y estilo." },
  { icon: Factory, title: "Fabricación a Medida",  text: "Producción a la medida con los más altos estándares de calidad." },
  { icon: Wrench,  title: "Instalación Profesional",  text: "Montaje profesional, limpio y al detalle. Listo para disfrutar." },
];

export default function Process() {
  return (
    <section id="proceso" data-testid="process-section" className="section bg-persia-black relative overflow-hidden">
      {/* subtle pattern */}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, #C9A227 0 1px, transparent 1px 18px)",
        }}
      />
      <div className="relative max-w-[1320px] mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-16 md:mb-24">
          <div className="eyebrow mb-5">Metodología</div>
          <h2 className="font-display font-semibold text-white text-3xl md:text-5xl leading-[1.1]">
            Así <span className="italic font-light text-gold">Trabajamos</span>
          </h2>
          <p className="mt-5 text-white/65 text-base md:text-lg font-light max-w-xl">
            Un proceso claro, cuidado y sin sorpresas — del primer contacto a la instalación final.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          <div className="hidden lg:block absolute top-7 left-7 right-7 h-px bg-gold/30" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-6">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={s.title}
                  data-testid={`process-step-${i}`}
                  initial={{ opacity: 0, y: 26 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.7, delay: i * 0.1 }}
                  className="relative"
                >
                  <div className="w-14 h-14 rounded-full border border-gold bg-persia-black flex items-center justify-center mb-6 relative z-10">
                    <Icon size={22} className="text-gold" />
                  </div>
                  <div className="font-display text-gold text-[11px] tracking-[0.3em] uppercase mb-3">
                    Paso {String(i + 1).padStart(2, "0")}
                  </div>
                  <h3 className="font-display text-white font-semibold text-xl mb-3">{s.title}</h3>
                  <p className="text-white/60 text-sm font-light leading-relaxed">{s.text}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
